import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtual from '../../actions/cteos/determinarPaginaAtualCteOs'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoCteOs extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtual}/>
  }
}

export function mapStateToProps (state) {
  return {
    total: state.emissoesCteOs.total,
    paginaAtual: state.paginaAtualCteOs,
    registrosPorPagina: state.registrosPorPaginalCteOs
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtual }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoCteOs)
